import { faAngleRight, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../Components/Table";
import LeiaMais from "../../../Components/Utils/LeiaMais";
import {
    ExportarExcelRepasseController,
    ListarGestaoRepasseController,
} from "../../../Controllers/Repasse/GestaoRepasse/GestaoRepasseController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import {
    IGestaoRepasseFiltro,
    IGestaoRepasseLista,
} from "../../../Interfaces/Repasse/GestaoRepasse/GestaoRepasseInterfaces";
import { ACESSOS } from "../../../Routes/Acessos";
import { formatMoneyReais } from "../../../Tools/FormatTools";
import StorageManagerCapys from "../../../Tools/Storage";
import AbrirCasoModal from "./AbrirCasoModal";
import FiltroGestaoRepasse from "./FiltroGestaoRepasse";
import { IPropsTableChange } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

interface IGestaoRepasseProps {}

export default function GestaoRepasse(_props: IGestaoRepasseProps) {
    const { PageFilter, setPage, filter, setPageFilter, setFilter } =
        usePaginationFilter<IGestaoRepasseFiltro>({ page: 1 });

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [pesquisaText, setPesquisaText] = useState("");

    const {
        value: gestaoRepasseLst,
        loading: gestaoRepasseLstLoading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        return ListarGestaoRepasseController({
            ...(PageFilter.filter ?? 0),
            ID_CONTA: PageFilter.filter?.ID_CONTA ?? 0,
            DT_FINAL_IN:
                PageFilter.filter?.DT_FINAL_IN &&
                PageFilter.filter?.DT_FINAL_IN?.length > 0
                    ? PageFilter.filter?.DT_FINAL_IN
                    : undefined,
            DT_FINAL_FN:
                PageFilter.filter?.DT_FINAL_FN &&
                PageFilter.filter?.DT_FINAL_FN?.length > 0
                    ? PageFilter.filter?.DT_FINAL_FN
                    : undefined,
            DT_INICIAL_IN:
                PageFilter.filter?.DT_INICIAL_IN &&
                PageFilter.filter?.DT_INICIAL_IN?.length > 0
                    ? PageFilter.filter?.DT_INICIAL_IN
                    : undefined,
            DT_INICIAL_FN:
                PageFilter.filter?.DT_INICIAL_FN &&
                PageFilter.filter?.DT_INICIAL_FN?.length > 0
                    ? PageFilter.filter?.DT_INICIAL_FN
                    : undefined,
            DS_NOME_CONTA:
                PageFilter.filter?.DS_NOME_CONTA &&
                PageFilter.filter?.DS_NOME_CONTA?.length > 0
                    ? PageFilter.filter?.DS_NOME_CONTA
                    : undefined,
            DS_NOME_CONTATO:
                PageFilter.filter?.DS_NOME_CONTATO &&
                PageFilter.filter?.DS_NOME_CONTATO?.length > 0
                    ? PageFilter.filter?.DS_NOME_CONTATO
                    : undefined,
            NR_STATUS:
                PageFilter.filter?.DS_STATUS_CASO &&
                PageFilter.filter?.DS_STATUS_CASO?.length > 0
                    ? nrStatus(PageFilter.filter?.DS_STATUS_CASO)
                    : 0,
            DS_STATUS_CASO:
                PageFilter.filter?.DS_STATUS_CASO &&
                PageFilter.filter?.DS_STATUS_CASO?.length > 0
                    ? PageFilter.filter?.DS_STATUS_CASO
                    : undefined,
            ID_CASO:
                PageFilter.filter?.ID_CASO && !isNaN(PageFilter.filter?.ID_CASO)
                    ? PageFilter.filter?.ID_CASO
                    : undefined,
            ID_SUBCATEGORIA:
                PageFilter.filter?.ID_SUBCATEGORIA &&
                PageFilter.filter?.ID_SUBCATEGORIA > 0
                    ? PageFilter.filter?.ID_SUBCATEGORIA
                    : undefined,
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                PageFilter.filter?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
            ID_EMPREENDIMENTO: PageFilter.filter?.ID_EMPREENDIMENTO,
            FL_ANDAMENTO: PageFilter.filter?.FL_ANDAMENTO ?? 0,
            ID_USUARIO_RESPONSAVEL:
                PageFilter.filter?.ID_USUARIO_RESPONSAVEL &&
                PageFilter.filter?.ID_USUARIO_RESPONSAVEL > 0
                    ? PageFilter.filter?.ID_USUARIO_RESPONSAVEL
                    : undefined,
            ID_ACOMPANHAMENTO:
                PageFilter.filter?.ID_ACOMPANHAMENTO &&
                PageFilter.filter?.ID_ACOMPANHAMENTO > 0
                    ? PageFilter.filter?.ID_ACOMPANHAMENTO
                    : 0,
            PAGINA: PageFilter.page,
        });
    }, [PageFilter.filter, PageFilter.page]);

    const totalPages = gestaoRepasseLst?.PAGINAS || 1;

    const FILTRO_GESTAO_ACORDOS_COBRANCA = sessionStorage.getItem(
        "FILTRO_GESTAO_REPASSE"
    );

    const defaultFilter = FILTRO_GESTAO_ACORDOS_COBRANCA
        ? JSON.parse(FILTRO_GESTAO_ACORDOS_COBRANCA)
        : filter;

    const filterStorage = new StorageManagerCapys<
        IGestaoRepasseFiltro | undefined
    >("FILTRO_GESTAO_REPASSE");

    const retornaIdProdutoExportarExcel = (
        ID_EMPREENDIMENTO: string | number | number[] | {}[]
    ): number => {
        if (typeof ID_EMPREENDIMENTO === "number") return ID_EMPREENDIMENTO;
        else if (typeof ID_EMPREENDIMENTO === "string")
            return Number(ID_EMPREENDIMENTO);
        else if (Array.isArray(ID_EMPREENDIMENTO))
            return Number(ID_EMPREENDIMENTO[0]);
        else return 0;
    };
    const nrStatus = (a: string): number => {
        switch (a) {
            case "Aberto":
                return 2;
            case "Fechado":
                return 3;
            default:
                return 0;
        }
    };

    const tableViewColumns: Array<ColumnDescription<IGestaoRepasseLista>> = [
        {
            dataField: "ID_CASO",
            text: "Solicitação",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => {
                return (
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="ver-atendimento-tooltip">
                                Ver Atendimento {c}
                            </Tooltip>
                        }
                    >
                        {row.ID_CASO ? (
                            <div className="d-flex flex-column g-2 align-items-center">
                                {c}
                                <Link
                                    to={ACESSOS.REPASSE.TELAS.ATENDIMENTO.DS_LINK(
                                        row.ID_CASO
                                    )}
                                    className="m-2 btn btn-icon btn-outline-info"
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                </Link>
                            </div>
                        ) : (
                            <span></span>
                        )}
                    </OverlayTrigger>
                );
            },
        },

        {
            dataField: "DS_NOME_CONTA",
            text: "Cliente / Financiamento",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (_c, row) => (
                <div className="d-flex flex-column g-2">
                    <h5>{row.DS_NOME_CONTA}</h5>
                    <span>CPF: {row.NR_CPF}</span>
                    <span
                        style={{
                            color:
                                row.VL_SUBSIDIO < row.VL_SUBSIDIO_APROVADO
                                    ? "red"
                                    : "#3F4254",
                        }}
                    >
                        Subsídio: {formatMoneyReais(row.VL_SUBSIDIO)}
                    </span>

                    {row.VL_FINANCIAMENTO && (
                        <span
                            style={{
                                color:
                                    row.VL_FINANCIAMENTO < row.VL_SICAQ_APROVADO
                                        ? "red"
                                        : "#3F4254",
                            }}
                        >
                            Financiamento:{" "}
                            {formatMoneyReais(row.VL_FINANCIAMENTO)}
                        </span>
                    )}

                    {row.VL_FGTS && (
                        <span
                            style={{
                                color:
                                    row.VL_FGTS < row.VL_FGTS_APROVADO
                                        ? "red"
                                        : "#3F4254",
                            }}
                        >
                            FGTS: {formatMoneyReais(row.VL_FGTS)}
                        </span>
                    )}
                </div>
            ),
        },
        {
            dataField: "DS_STATUS",
            text: "Total Aprovado",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (_c, row) => (
                <h4>
                    {formatMoneyReais(
                        row.VL_FINANCIAMENTO + row.VL_SUBSIDIO + row.VL_FGTS
                    )}
                </h4>
            ),
        },
        {
            dataField: "DS_PRODUTO",
            text: "Unidade / Empreendimento",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (_c, row) => (
                <>
                    <h5>{row.DS_PRODUTO}</h5>
                    <span>{row.DS_PRODUTO_PAI}</span>
                </>
            ),
        },
        {
            dataField: "DT_VALIDADE_ANALISE_CREDITO",
            text: "Analise de Crédito",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (_c, row) => (
                <div className="d-flex flex-column g-1 justify-content-center aligm-items-center">
                    <h5 className="mt-2">
                        Validade:{" "}
                        {row.DT_VALIDADE_ANALISE_CREDITO &&
                            new Date(
                                row.DT_VALIDADE_ANALISE_CREDITO
                            ).toLocaleDateString()}
                    </h5>
                    <span>Status: {row.DS_STATUS_ANALISE_CREDITO}</span>
                    <span>
                        SICAQ: {formatMoneyReais(row.VL_SICAQ_APROVADO)}
                    </span>
                    <span>
                        Subsídio: {formatMoneyReais(row.VL_SUBSIDIO_APROVADO)}
                    </span>
                </div>
            ),
        },
        {
            dataField: "DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO",
            text: "Etapa de Repasse / Solicitação",
            headerClasses: "font-size-h8 font-weight-bold",

            // formatter: (c, row) => (
            //     <div>
            //         <h5>{row.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}</h5>
            //         <span>{row.DS_EQUIPE_VENDAS_RESPONSAVEL}</span>
            //     </div>
            // ),
        },
        {
            dataField: "DS_ULTIMO_HISTORICO",
            text: "Último Comentário",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (_c, row) => (
                <div>
                    <LeiaMais charLimit={40}>
                        {row.DS_ULTIMO_HISTORICO}
                    </LeiaMais>
                </div>
            ),
        },
        {
            dataField: "DT_INICIO",
            text: "Início / Fim / Prazo",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <span className="bold">
                        Início: {c ? new Date(c).toLocaleString() : "-"}
                    </span>
                    <br />
                    {row.DT_FIM && (
                        <span className="bold">
                            Fim:{" "}
                            {row.DT_FIM
                                ? new Date(row.DT_FIM).toLocaleString()
                                : "-"}
                        </span>
                    )}
                </div>
            ),
        },
        {
            dataField: "",
            text: "Ações",
            formatter: (_, row) => {
                return !row.ID_CASO ? (
                    <>
                        <div className="Button-Tools ml-5">
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Abrir Atendimento",
                                        IconHeader: faAngleRight,
                                        Component: () => (
                                            <AbrirCasoModal
                                                gestaoRepasse={row}
                                                setShow={setShow}
                                                updateList={updateList}
                                            />
                                        ),
                                        size: "xl",
                                        noFooter: true,
                                    });
                                }}
                            >
                                Abrir Caso
                            </button>
                        </div>
                    </>
                ) : (
                    ""
                );
            },
        },
    ];
    const ultimaPesquisaRef = useRef("");
    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    ...PageFilter.filter,
                    PESQUISA: newState.searchText,
                });
            }
        }, 1000);
    }

    return (
        <div className="card card-custom p-5">
            <Table
                keyField="ID_CASO"
                columns={tableViewColumns}
                wrapperClasses="mw-100 custom-scroll"
                data={gestaoRepasseLst?.ATENDIMENTOS_REPASSE ?? []}
                loading={gestaoRepasseLstLoading}
                onTableChange={(_type, newState) => {
                    const state = newState as IPropsTableChange;

                    if (state.searchText !== "") {
                        handleSearch(state.searchText, state);
                        setPesquisaText(state.searchText);
                    } else if (pesquisaText.length > 0) {
                        setFilter({ PESQUISA: state.searchText });
                    } else {
                        setPage(state.page);
                    }
                }}
                remote={{ pagination: true, filter: true }}
                totalPages={totalPages}
                rowStyle={{ height: 80 }}
                bordered={false}
                defaultStyle={{ align: "center" }}
                rowClasses={"rowClasses"}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhuma análise de crédito encontrada
                    </div>
                )}
            />

            <FiltroGestaoRepasse
                handleSubmit={(formData) => {
                    setPageFilter({
                        filter: {
                            ...formData,
                        },
                        page: 1,
                    });
                }}
                storageManager={filterStorage}
                defaultFilter={defaultFilter}
                setIdEmpreendimento={() => {}}
            />

            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelRepasseController({
                        DT_FIM_IN: PageFilter.filter?.DT_FIM_IN,
                        DT_FIM_FN: PageFilter.filter?.DT_FIM_FN,
                        DT_INICIO_IN: PageFilter.filter?.DT_INICIO_IN,
                        DT_INICIO_FN: PageFilter.filter?.DT_INICIO_IN,
                        ID_PRODUTO: PageFilter.filter?.ID_EMPREENDIMENTO
                            ? retornaIdProdutoExportarExcel(
                                  PageFilter.filter?.ID_EMPREENDIMENTO
                              )
                            : PageFilter.filter?.ID_PRODUTO,
                        PAGINA: 0,
                    })
                }
                nomeArquivo={"Controle de Financiamento"}
            />

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
